import { Box } from '@mui/material';
import { orange } from '@mui/material/colors';
import { FC } from 'react';

type Props = {
  /** 通常はメニュー / ヘッダ脇の小さい場合 'sm'。タイトル横で目立たせる場合 'md' */
  size?: 'sm' | 'md';
};

/**
 * ベータ版機能を示す共通バッジ。
 * ヘッダメニュー / ダッシュボード / レーン管理ページなど複数箇所で使う。
 * 背景は最薄のオレンジ (orange[50])、枠 / 文字を warning.dark で濃く。
 */
const BetaBadge: FC<Props> = ({ size = 'sm' }) => {
  const fontSize = size === 'sm' ? '0.65rem' : '0.75rem';
  const padX = size === 'sm' ? 0.75 : 1;
  const padY = size === 'sm' ? 0.25 : 0.375;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        ml: 1,
        px: padX,
        py: padY,
        fontSize,
        fontWeight: 700,
        lineHeight: 1,
        color: 'warning.dark',
        bgcolor: orange[50],
        border: '1px solid',
        borderColor: 'warning.dark',
        borderRadius: 1,
        whiteSpace: 'nowrap',
      }}
    >
      ﾍﾞｰﾀ版
    </Box>
  );
};

export default BetaBadge;
